var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11334 31.4078C7.48814 34.1917 9.79388 36.3725 12.5998 36.5015C14.9608 36.61 17.3592 36.6667 20.0003 36.6667C22.6415 36.6667 25.0398 36.61 27.4008 36.5015C30.2068 36.3725 32.5125 34.1917 32.8873 31.4078C33.132 29.5912 33.3337 27.7293 33.3337 25.8333C33.3337 23.9373 33.132 22.0755 32.8873 20.2588C32.5125 17.475 30.2068 15.2941 27.4008 15.1651C25.0398 15.0566 22.6415 15 20.0003 15C17.3592 15 14.9608 15.0566 12.5998 15.1651C9.79388 15.2941 7.48814 17.475 7.11334 20.2588C6.86874 22.0755 6.66699 23.9373 6.66699 25.8333C6.66699 27.7293 6.86874 29.5912 7.11334 31.4078Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.9987V10.832C12.5 6.6899 15.8579 3.33203 20 3.33203C24.1422 3.33203 27.5 6.6899 27.5 10.832V14.9987",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 25.8164V25.8331",
    stroke: "#4956F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.8164V25.8331",
    stroke: "#4956F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 25.8164V25.8331",
    stroke: "#4956F4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockPassword);
export default __webpack_public_path__ + "static/media/lock-password.a699fd53f11cd585065a5b8df22d1e21.svg";
export { ForwardRef as ReactComponent };